import { Map } from 'immutable'
import errors from '../../config/errors'

import {
  ACTIVATION_ERROR,
  ACTIVATION_SUCCESS,
  ACTIVATION_LOADING
} from './action-types'

const initialState = Map({
  data: null,
  error: errors.basic,
  isLoading: null,
  isSuccess: null,
  hasError: null
})

const activationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVATION_SUCCESS:
      return state
        .set('isLoading', false)
        .set('isSuccess', true)
        .set('hasError', false)
        .set('data', action.payload)
        .set('error', errors.basic)
    case ACTIVATION_ERROR:
      return state
        .set('isLoading', false)
        .set('isSuccess', false)
        .set('hasError', true)
        .set('error', action.error)
    case ACTIVATION_LOADING:
      return state
        .set('isLoading', true)
        .set('isSuccess', false)
        .set('hasError', false)
        .set('error', errors.basic)
    default:
      return state
  }
}

export default activationReducer
